// let apiUrl = "/components/" + data.id + "/shades?filterbyzone=1&disablecampaign=0&isactivated=1";

import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    fromIds(/** @type {number[]} */ ids, { brandId, zoneId, campaignId }) {
        console.assert(typeof brandId === "number");
        console.assert(typeof zoneId === "number");
        console.assert(typeof campaignId === "number");

        console.assert(Array.isArray(ids));
        console.assert(!ids.some(id => typeof id !== "number"));
        return http.get(
            buildUrlFromLocation(`/shades?ids=${ids.join(",")}`, {
                brandId,
                zoneId,
                campaignId
            })
        );
    },
    fromProduct(moduleId) {
        console.assert(typeof moduleId === "number");
        // TODO: paginate the request
        return http.get(buildUrlFromLocation(`/components/${moduleId}/shades`));
    }
};



// WEBPACK FOOTER //
// ./src/services/shades.js